import React from 'react'
import { Head, Link, useForm } from '@inertiajs/react'
import { Container, Typography, Box, Button, Paper, Stack, TextField } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

export default function NewCompany() {
  const { data, setData, post, processing, errors } = useForm({
    name: '',
    country: '',
    website_url: '',
    description: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/companies', { data: { company: data } })
  }

  return (
    <>
      <Head title="New Company" />
      <Container maxWidth="sm" sx={{ py: 5 }}>
        <Box sx={{ mb: 4 }}>
          <Button
            component={Link}
            href="/companies"
            startIcon={<ArrowBackIcon />}
            sx={{ mb: 2 }}
          >
            Back to Companies
          </Button>
          <Typography variant="h5">New Company</Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <Paper sx={{ p: 4, mb: 4 }}>
            <Stack spacing={2.5}>
              <TextField
                label="Name"
                value={data.name}
                onChange={(e) => setData('name', e.target.value)}
                error={!!errors.name}
                helperText={(errors as any).name?.[0]}
                required
                fullWidth
              />
              <TextField
                label="Country"
                value={data.country}
                onChange={(e) => setData('country', e.target.value)}
                fullWidth
                placeholder="e.g. South Korea"
              />
              <TextField
                label="Website"
                value={data.website_url}
                onChange={(e) => setData('website_url', e.target.value)}
                fullWidth
                placeholder="https://..."
              />
              <TextField
                label="Description"
                value={data.description}
                onChange={(e) => setData('description', e.target.value)}
                fullWidth
                multiline
                rows={3}
              />
            </Stack>
          </Paper>

          <Button type="submit" variant="contained" disabled={processing}>
            Create Company
          </Button>
        </form>
      </Container>
    </>
  )
}
